var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"mt--7",attrs:{"fluid":""}},[_c('create-vehicle-form',{ref:"createVehicle",on:{"success":_vm.created}}),_c('fleet-table',{ref:"table",attrs:{"title":"Users"},on:{"addVehicle":_vm.showVehicleModal}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }